import { Typography } from "@mui/material";

import { formatSplitForDisplay } from "../utils/paymentFormUtils";

export default function PaymentsRowDetails({ data }) {
  return (
    <div className="grid grid-cols-1 gap-3 rounded-[12px] bg-slate-50 p-4 md:grid-cols-2">
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Routing Number
        </Typography>
        <Typography className="text-sm text-slate-700">{data.routingNumber ?? "N/A"}</Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Account Number
        </Typography>
        <Typography className="text-sm text-slate-700">{data.accountNumber ?? "N/A"}</Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Client Management Split
        </Typography>
        <Typography className="text-sm text-slate-700">
          {formatSplitForDisplay(data.clientManagementSplit)}
        </Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Provider Split
        </Typography>
        <Typography className="text-sm text-slate-700">
          {formatSplitForDisplay(data.providerSplit)}
        </Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Marketing Split
        </Typography>
        <Typography className="text-sm text-slate-700">
          {formatSplitForDisplay(data.marketingSplit)}
        </Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Review Contract
        </Typography>
        <Typography className="text-sm text-slate-700">
          {data.reviewContract ? "Yes" : "No"}
        </Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Billing Address
        </Typography>
        <Typography className="text-sm text-slate-700">
          {data.billingAddress?.formatted ?? "N/A"}
        </Typography>
      </div>
      <div>
        <Typography className="text-xs font-semibold uppercase text-slate-500">
          Mailing Address
        </Typography>
        <Typography className="text-sm text-slate-700">
          {data.mailingAddress?.formatted ?? "N/A"}
        </Typography>
      </div>
    </div>
  );
}
